import { gql } from "graphql-request";

export const GET_ALL_CLIENTS = gql`
  query GetAllSpClients(
    $pageNo: Int
    $pageSize: Int
    $searchKeyword: String
    $assignedPartner: String
    $startDate: String
    $endDate: String
    $isRestricted: Boolean
    $tenantId: String
  ) {
    getAllSpClients(
      pageNo: $pageNo
      pageSize: $pageSize
      searchKeyword: $searchKeyword
      assignedPartner: $assignedPartner
      startDate: $startDate
      endDate: $endDate
      isRestricted: $isRestricted
      tenantId: $tenantId
    ) {
      data {
        _id
        createdAt
        firstName
        lastName
        profileImage
        email
        isRestricted
        assignedPartner
        cognitoUserId
        clientPermission {
          dashboard
          documents
          reports
        }
        allowedPages
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const ADD_CLIENT = gql`
  mutation CreateClient($clientData: CreateClientInput!) {
    createClient(clientData: $clientData) {
      data
    }
  }
`;

export const UPDATE_CLIENT = gql`
  mutation UpdateClientInfo(
    $clientId: String!
    $clientData: UpdateClientInput!
  ) {
    updateClientInfo(clientId: $clientId, clientData: $clientData) {
      data
    }
  }
`;

export const DELETE_CLIENT_BY_ID = gql`
  mutation DeleteUserById($userId: String! ,$tenantId: String) {
    deleteUserById(userId: $userId,tenantId: $tenantId) {
      data
    }
  }
`;

export const UPDATE_CLIENT_STATUS = gql`
  mutation UpdateUserBlockStatus($email: String, $isRestricted: Boolean) {
    updateUserBlockStatus(email: $email, isRestricted: $isRestricted) {
      data
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;
